/* eslint-disable react-hooks/exhaustive-deps,import/no-unresolved */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import MainImage from 'assets/images/otc.png';
import Sales from './modals/Sales';
import CommunicateOptions from './modals/CommunicateOptions';
import ModalLayout from '../shared/ModalLayout';
import {
  DEFAULT_DESTINATION_CURRENCY,
  DEFAULT_SOURCE_CURRENCY,
  MODAL_SCREENS,
  SALES_TABS,
} from './constants';
import {
  useLedgerFilteredCurrencies,
  useLedgerFilteredWallets,
} from '../../utilities/sharedHooks/ledgerWallets';
import {
  SETTINGS_SUPPORTED_CURRENCIES_QUERY_KEY,
  USER_PREFERENCES,
} from '../../utilities/sharedQueries';
import { WALLETS_ALL } from '../Accounts/queries';
import Currencies from './modals/Currencies';
import { useSetting } from '../../utilities/sharedHooks/settings';

const OTC = () => {
  const { t: translate } = useTranslation();

  const history = useHistory();

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [currentScreen, setCurrentScreen] = useState('');

  const showScreen = (screen) => {
    setCurrentScreen(screen);
    setIsModalVisible(true);
  };

  const { data: userPref, refetch: refetchUserPerf } = useQuery(USER_PREFERENCES, {
    enabled: false,
  });

  const fiatCurrencyCode = userPref?.displayCurrency || 'EUR';

  const { data: wallets } = useLedgerFilteredWallets(WALLETS_ALL);

  const { data: supportedCurrencies } = useLedgerFilteredCurrencies([
    SETTINGS_SUPPORTED_CURRENCIES_QUERY_KEY,
  ]);

  const [activeTab, setActiveTab] = useState(SALES_TABS.BUY);

  const [form, updateForm] = useState({
    source: '',
    destination: '',
    sourceAmount: 0,
    destinationAmount: 0,
    sourceWallet: null,
    destinationWallet: null,
    isOpenSourceCurrencies: false,
    tradeType: SALES_TABS.BUY,
  });

  const [allowOTCFeature] = useSetting('app_features', 'feature_allow_otc');

  useEffect(() => {
    if (allowOTCFeature === false) {
      history.push(`/`);
    }
  }, [allowOTCFeature]);

  useEffect(() => {
    refetchUserPerf();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (supportedCurrencies && wallets) {
      updateForm({
        ...form,

        source:
          activeTab === SALES_TABS.BUY
            ? supportedCurrencies[DEFAULT_SOURCE_CURRENCY]
            : supportedCurrencies[DEFAULT_DESTINATION_CURRENCY],

        destination:
          activeTab === SALES_TABS.BUY
            ? supportedCurrencies[DEFAULT_DESTINATION_CURRENCY]
            : supportedCurrencies[DEFAULT_SOURCE_CURRENCY],

        sourceWallet:
          activeTab === SALES_TABS.BUY
            ? wallets.find((wallet) => wallet.coin === DEFAULT_SOURCE_CURRENCY)
            : wallets.find((wallet) => wallet.coin === DEFAULT_DESTINATION_CURRENCY),

        destinationWallet:
          activeTab === SALES_TABS.BUY
            ? wallets.find((wallet) => wallet.coin === DEFAULT_DESTINATION_CURRENCY)
            : wallets.find((wallet) => wallet.coin === DEFAULT_SOURCE_CURRENCY),
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [supportedCurrencies, wallets, activeTab]);

  const renderButtonSection = () => (
    <div className="w-100">
      <button
        type="button"
        onClick={() => showScreen(MODAL_SCREENS.SALES)}
        className="btn btn-primary mt-4 w-100">
        {translate('promo_OTC_get_quote_btn_label')}
      </button>
    </div>
  );

  return (
    <div className="container p-0">
      <div className="otc-main-banner">
        <div className="row flex-row justify-content-center align-items-center mt-4">
          {/* mobile layout */}
          <p className="d-block d-md-none text-f3 text-bold">
            {translate('promo_OTC_title_mobile')}
          </p>

          <div className="col-12 col-md-6 text-center text-md-start ps-0 ps-md-5">
            {/* mobile layout */}
            <img className="d-block d-md-none w-75" src={MainImage} alt="no-loans" />

            {/* browser layout */}
            <img className="d-none d-md-block w-100" src={MainImage} alt="no-loans" />
          </div>

          <div className="col-12 col-md-6 my-lg-5 mt-md-5 mb-md-4">
            {/* mobile layout */}
            <div className="d-block d-md-none m-auto">
              <p className="text-f2 text-bold d-lg-block d-none" style={{ lineHeight: '3.5rem' }}>
                {translate('promo_OTC_title')}
              </p>

              <p className="text-shadow mt-lg-3 me-4 text-f5">{translate('promo_OTC_main_note')}</p>

              <ul className="mt-4 p-0" style={{ listStyle: 'none' }}>
                {/* mobile layout */}
                <li className="d-block d-md-none text-f5 mt-3">
                  <div className="d-flex flex-row align-items-center">
                    <i className="icon icon-done-status me-2 text-primary" />
                    <p>{translate('promo_OTC_note_1')}</p>
                  </div>
                </li>
                {/* browser layout */}
                <li className="d-none d-md-block text-f6 mt-2">
                  <div className="d-flex flex-row align-items-center">
                    <i className="icon icon-done-status me-2 text-primary" />
                    <p>{translate('promo_OTC_note_1')}</p>
                  </div>
                </li>

                {/* mobile layout */}
                <li className="d-block d-md-none text-f5 mt-3">
                  <div className="d-flex flex-row align-items-center">
                    <i className="icon icon-done-status me-2 text-primary" />
                    <p>{translate('promo_OTC_note_2')}</p>
                  </div>
                </li>
                {/* browser layout */}
                <li className="d-none d-md-block text-f6 mt-2">
                  <div className="d-flex flex-row align-items-center">
                    <i className="icon icon-done-status me-2 text-primary" />
                    <p>{translate('promo_OTC_note_2')}</p>
                  </div>
                </li>

                {/* mobile layout */}
                <li className="d-block d-md-none text-f5 mt-3">
                  <div className="d-flex flex-row align-items-center">
                    <i className="icon icon-done-status me-2 text-primary" />
                    <p>{translate('promo_OTC_note_3')}</p>
                  </div>
                </li>
                {/* browser layout */}
                <li className="d-none d-md-block text-f6 mt-2">
                  <div className="d-flex flex-row align-items-center">
                    <i className="icon icon-done-status me-2 text-primary" />
                    <p>{translate('promo_OTC_note_3')}</p>
                  </div>
                </li>

                {/* mobile layout */}
                <li className="d-block d-md-none text-f5 mt-3">
                  <div className="d-flex flex-row align-items-center">
                    <i className="icon icon-done-status me-2 text-primary" />
                    <p>{translate('promo_OTC_note_4')}</p>
                  </div>
                </li>
                {/* browser layout */}
                <li className="d-none d-md-block text-f6 mt-2">
                  <div className="d-flex flex-row align-items-center">
                    <i className="icon icon-done-status me-2 text-primary" />
                    <p>{translate('promo_OTC_note_4')}</p>
                  </div>
                </li>
              </ul>

              <div className="d-lg-block d-md-none d-sm-none d-none">{renderButtonSection()}</div>
            </div>

            {/* browser layout */}
            <div className="d-none d-md-block col-10 m-auto">
              <p className="text-f2 text-bold" style={{ lineHeight: '3.5rem' }}>
                {translate('promo_OTC_title')}
              </p>

              <p className="text-shadow mt-md-3 me-4 text-f5">{translate('promo_OTC_main_note')}</p>

              <ul className="mt-4 p-0" style={{ listStyle: 'none' }}>
                {/* mobile layout */}
                <li className="d-block d-md-none text-f5 mt-3">
                  <div className="d-flex flex-row align-items-center">
                    <i className="icon icon-done-status me-2 text-primary" />
                    <p>{translate('promo_OTC_note_1')}</p>
                  </div>
                </li>
                {/* browser layout */}
                <li className="d-none d-md-block text-f6 mt-2">
                  <div className="d-flex flex-row align-items-center">
                    <i className="icon icon-done-status me-2 text-primary" />
                    <p>{translate('promo_OTC_note_1')}</p>
                  </div>
                </li>

                {/* mobile layout */}
                <li className="d-block d-md-none text-f5 mt-3">
                  <div className="d-flex flex-row align-items-center">
                    <i className="icon icon-done-status me-2 text-primary" />
                    <p>{translate('promo_OTC_note_2')}</p>
                  </div>
                </li>
                {/* browser layout */}
                <li className="d-none d-md-block text-f6 mt-2">
                  <div className="d-flex flex-row align-items-center">
                    <i className="icon icon-done-status me-2 text-primary" />
                    <p>{translate('promo_OTC_note_2')}</p>
                  </div>
                </li>

                {/* mobile layout */}
                <li className="d-block d-md-none text-f5 mt-3">
                  <div className="d-flex flex-row align-items-center">
                    <i className="icon icon-done-status me-2 text-primary" />
                    <p>{translate('promo_OTC_note_3')}</p>
                  </div>
                </li>
                {/* browser layout */}
                <li className="d-none d-md-block text-f6 mt-2">
                  <div className="d-flex flex-row align-items-center">
                    <i className="icon icon-done-status me-2 text-primary" />
                    <p>{translate('promo_OTC_note_3')}</p>
                  </div>
                </li>

                {/* mobile layout */}
                <li className="d-block d-md-none text-f5 mt-3">
                  <div className="d-flex flex-row align-items-center">
                    <i className="icon icon-done-status me-2 text-primary" />
                    <p>{translate('promo_OTC_note_4')}</p>
                  </div>
                </li>
                {/* browser layout */}
                <li className="d-none d-md-block text-f6 mt-2">
                  <div className="d-flex flex-row align-items-center">
                    <i className="icon icon-done-status me-2 text-primary" />
                    <p>{translate('promo_OTC_note_4')}</p>
                  </div>
                </li>
              </ul>

              <div className="d-md-block d-none">{renderButtonSection()}</div>
            </div>
          </div>
        </div>

        <div className="row d-block d-md-none mb-5">
          <div className="col-12">
            <div className="d-flex flex-row w-100 justify-content-center align-items-center">
              {renderButtonSection()}
            </div>
          </div>
        </div>
      </div>

      <div className="d-none d-md-flex row" style={{ marginTop: '4rem' }}>
        <div className="col-4">
          <div className="d-flex flex-column justify-content-center align-items-center">
            <div
              className="bg-lighter px-3 pt-3 pb-2 d-flex justify-content-center align-items-center position-relative"
              style={{ borderRadius: '2rem' }}>
              <i className="icon icon-not-integrated text-white text-f3 pb-1" />

              <div
                className="bg-primary text-f5 rounded-max position-absolute px-2 py-0"
                style={{ top: 0, left: 0 }}>
                1
              </div>
            </div>

            <p className="text-white text-f5 mt-3">{translate('promo_OTC_step_1_title')}</p>

            <p className="text-shadow text-f5 mt-2 text-center">
              {translate('promo_OTC_step_1_description_1')}
              <span className="text-primary px-1">
                {translate('promo_OTC_step_1_description_2')}
              </span>
              {translate('promo_OTC_step_1_description_3')}
            </p>
          </div>
        </div>

        <div className="col-4">
          <div className="d-flex flex-column justify-content-center align-items-center">
            <div
              className="bg-lighter p-3 d-flex justify-content-center align-items-center position-relative"
              style={{ borderRadius: '2rem' }}>
              <img
                src="./assets/icons/document-other.svg"
                alt="check"
                style={{ maxHeight: '2rem' }}
              />

              <div
                className="bg-primary text-f5 rounded-max position-absolute px-2 py-0"
                style={{ top: 0, left: 0 }}>
                2
              </div>
            </div>

            <p className="text-white text-f5 mt-3">{translate('promo_OTC_step_2_title')}</p>

            <p className="text-shadow text-f5 mt-2 text-center">
              {translate('promo_OTC_step_2_description')}
            </p>
          </div>
        </div>

        <div className="col-4">
          <div className="d-flex flex-column justify-content-center align-items-center">
            <div
              className="bg-lighter p-3 d-flex justify-content-center align-items-center position-relative"
              style={{ borderRadius: '2rem' }}>
              <img src="./assets/icons/new-check.svg" alt="check" className="p-1" />

              <div
                className="bg-primary text-f5 rounded-max position-absolute px-2 py-0"
                style={{ top: 0, left: 0 }}>
                3
              </div>
            </div>

            <p className="text-white text-f5 mt-3">{translate('promo_OTC_step_3_title')}</p>

            <p className="text-shadow text-f5 mt-2 text-center">
              {translate('promo_OTC_step_3_description')}
            </p>
          </div>
        </div>
      </div>

      <ModalLayout
        onHide={() => setIsModalVisible(false)}
        isVisible={isModalVisible}
        currentScreen={currentScreen}>
        <Sales
          keyName={MODAL_SCREENS.SALES}
          form={form}
          updateForm={updateForm}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          fiatCurrencyCode={fiatCurrencyCode}
          openScreen={setCurrentScreen}
        />

        <Currencies
          keyName={MODAL_SCREENS.CURRENCIES}
          wallets={wallets}
          currencies={supportedCurrencies}
          openScreen={setCurrentScreen}
          form={form}
          updateForm={updateForm}
          mainScreen={MODAL_SCREENS.SALES}
          isOpenSourceCurrencies={form.isOpenSourceCurrencies}
        />

        <CommunicateOptions
          form={form}
          openScreen={setCurrentScreen}
          hide={() => setIsModalVisible(false)}
          keyName={MODAL_SCREENS.COMMUNICATE_OPTIONS}
        />
      </ModalLayout>
    </div>
  );
};

export default OTC;
